import { action, mutator } from 'satcheljs';
import { getStore } from '../store/store';
import getTabIdFromWindow from '../utils/getTabIdFromWindow';

export interface DrawerPaneWidthChangedActionMessage {
    paneId: string;
    width: number;
    targetWindow?: Window;
}

export const drawerPaneWidthChanged: (
    paneId: string,
    width: number,
    targetWindow?: Window
) => DrawerPaneWidthChangedActionMessage = action(
    'drawerPaneWidthChanged',
    (
        paneId: string,
        width: number,
        targetWindow?: Window
    ): DrawerPaneWidthChangedActionMessage => ({
        paneId,
        width,
        targetWindow,
    })
);

mutator(drawerPaneWidthChanged, actionMessage => {
    const tabId = getTabIdFromWindow(actionMessage.targetWindow);
    const existing = getStore().paneStateMap.get(tabId)?.get(actionMessage.paneId);

    if (existing) {
        existing.currentWidth = actionMessage.width;
    }
    // If no entry exists, ignore — width sync only applies to open panes.
    // The entry is created by drawerPaneShownChanged when the pane opens.
});
